/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import BaseController from "./BaseController";
import Navigation from "../../../Navigation";
import {PageActionActions, GotoBackAction, RefreshAction} from "../../../services/PageAction";

class DeleteController extends BaseController {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};

    getActionData(a) {
        if (this.state.resource)
            return this.state.resource.currentRecord;
        return null;
    }

    /**
     *
     * @param {PageAction} action
     * @returns {boolean}
     */
    onAction(action) {
        switch (action.action) {
            case "delete":
                this.setState({finish: false, ignoreFinish: false}, function () {
                    this.actions().del(this.props.params.id);
                }.bind(this));
                break;
            default:
                return super.onAction(action);
        }
        return true;
    }

    loadingFinished(key, newState) {
        if (key === "resource" && newState.action.method === "del") {
            // Navigate back until we are out from current resource record:
            Navigation.replaceBackOutsideResource();

            let newState = {finish: true};
            if (this.state.finish) newState.ignoreFinish = true;
            this.setState(newState);
        }
    }

    render() {
        if (this.state.finish && !this.state.ignoreFinish) {
            return (<div/>);
        }
        return super.render();
    }
}

export default DeleteController;
